<div class="flex-1 d-flex flex-wrap">

  <ng-container *ngFor="let itemWidth of legend">

    <div class="chip" [ngStyle]="{
      width: itemWidth
    }">
      <ngx-skeleton-loader [theme]="{
        width: '100%',
        height: '100%'
      }"></ngx-skeleton-loader>
    </div>

  </ng-container>

</div>
